module.exports = __webpack_public_path__ + "assets/keyboard_arrow_down.110c7a78.svg";